import { $http } from '@tajawal/web-core-sdk-v2/lib/services/http.service';
import { ENDPOINTS } from "../constants/index.js";
/**
 * country client
 */
export var CountryClient = {
  /**
   * get currency list
   * @returns {Promise}
   */
  getCountryList: function getCountryList() {
    var requestId = 'COUNTRY_LIST';
    return $http.get(requestId, ENDPOINTS.COUNTRY_LIST).then(function (_ref) {
      var data = _ref.data;
      return data;
    });
  }
};